import { NAV_LINKS } from "../data/content";
import { useDiscovery } from "./publicCampaigns";

/** NAV_LINKS with "Campaigns" pointing at the real grid once discovery is visible. */
export const useNavLinks = () => {
  const { visible } = useDiscovery();
  return NAV_LINKS.map((l) => (l.label === "Campaigns" && visible ? { ...l, href: "/campaigns" } : l));
};
